if (!customElements.get('article-modal')) {
  class ArticleModal extends HTMLElement {
    constructor() {
      super();

      this.handleOpenRef = this.handleOpen.bind(this);
      this.handleCloseRef = this.handleClose.bind(this);
    }

    handleClose() {
      this.parentElement.classList.remove('is-open');

      bodyScroll.clear();
      window.scrollTo({ top: this.currentScroll, behavior: 'instant' });
    }

    handleOpen(event) {
      if (!event.detail.innerHTML) return;

      this.innerHTML = event.detail.innerHTML;

      this.parentElement.classList.add('is-open');
      this.currentScroll = window.scrollY;
      bodyScroll.lock(this);
    }

    disconnectedCallback() {
      document.removeEventListener('article-modal:open', this.handleOpenRef);
      document.removeEventListener('article-modal:close', this.handleCloseRef);
    }

    connectedCallback() {
      document.addEventListener('article-modal:open', this.handleOpenRef);
      document.addEventListener('article-modal:close', this.handleCloseRef);
    }
  }

  customElements.define('article-modal', ArticleModal);
}
